module.exports = __webpack_public_path__ + "media/1x1/ru-e3ee3b09.svg";